import React from 'react';
import { FileText, Building2 } from 'lucide-react';

const Leases = () => {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="leases-page">
      {/* Page Header */}
      <div>
        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Lease Management
        </h1>
        <p className="text-slate-500 mt-1">
          Manage lease agreements and tenant contracts across your portfolio.
        </p>
      </div>

      {/* Coming Soon Card */}
      <div className="chart-container flex flex-col items-center justify-center py-16">
        <div className="w-16 h-16 bg-[#EFF6FF] rounded-2xl flex items-center justify-center mb-4">
          <FileText className="w-8 h-8 text-[#1A56DB]" />
        </div>
        <h2 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Lease Management Coming Soon
        </h2>
        <p className="text-slate-500 text-center max-w-md">
          This feature is currently under development. Soon you'll be able to manage lease agreements, 
          track renewals, and handle tenant contracts all in one place.
        </p>
      </div>
    </div>
  );
};

export default Leases;
